module.exports = __webpack_public_path__ + "img/fv_title.c62c278e.svg";